import { createReducer, on, Action } from '@ngrx/store';

import * as CopyCropFieldsToManureSpaceActions from './copy-cropfields-to-manure-space.actions';
import { CopyCropFieldsToManureSpaceState } from '../copy-cropfields-to-manure-space.models';

const copyCropFieldsToManureSpaceReducer = createReducer<CopyCropFieldsToManureSpaceState>(
  {},
  on(
    CopyCropFieldsToManureSpaceActions.copyCropFieldsToManureSpaceStarted,
    (state, { amountOfCropFields }) => ({
      ...state,
      amountOfCropFieldsCopying: (state.amountOfCropFieldsCopying ?? 0) + amountOfCropFields,
      copyDialogDismissed: false,
      copyStatusDismissed: false,
    }),
  ),
  on(CopyCropFieldsToManureSpaceActions.copyCropFieldsToManureSpaceCompleted, (state) => ({
    ...state,
    amountOfCropFieldsCompleted: (state.amountOfCropFieldsCompleted ?? 0) + 1,
  })),
  on(CopyCropFieldsToManureSpaceActions.completedCopyAll, (state) => ({
    ...state,
    amountOfCropFieldsCopying: 0,
    amountOfCropFieldsCompleted: 0,
  })),
  on(CopyCropFieldsToManureSpaceActions.copyDialogDismissed, (state) => ({
    ...state,
    copyDialogDismissed: true,
  })),
  on(CopyCropFieldsToManureSpaceActions.dismissCopyCropFieldsStatus, (state) => ({
    ...state,
    copyStatusDismissed: true,
  })),
);

export const reducer = (state: CopyCropFieldsToManureSpaceState | undefined, action: Action) =>
  copyCropFieldsToManureSpaceReducer(state, action);
